import React, { useContext, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ProgressBar from "../ProgressBar/ProgressBar";
import { AuthContext } from "../Context/AuthContext"; // adjust path if needed
import AuthPromptDialog from "../AuthPromptDialog/AuthPromptDialog"; // adjust path if needed

const DocumentCard = ({ doc }) => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [authOpen, setAuthOpen] = useState(false);

  const handleViewDocument = () => {
    const target = `/transcription/documents/${doc.documentId}`;

    if (!user) {
      setAuthOpen(true);
      return;
    }

    navigate(target);
  };

  const hasLongDescription = doc.description && doc.description.length > 80;
  const shortDescription = hasLongDescription
    ? doc.description.slice(0, 80).trimEnd() + "..."
    : doc.description;

  return (
    <>
      <Box
        sx={{
          width: "400px",
          padding: "20px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "12px",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 8px 16px rgba(0,0,0,0.15)",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={doc.pages?.[0]?.imageUrl}
            alt={doc.title}
            sx={{
              width: "200px",
              height: "300px",
              objectFit: "cover",
              borderRadius: "12px",
            }}
          />
        </Box>

        <Typography
          variant="h6"
          sx={{ fontWeight: "600", color: "#333", fontSize: "1.2rem" }}
          noWrap
        >
          {doc.title}
        </Typography>

        <Box sx={{ minHeight: 40, display: "flex", alignItems: "flex-start" }}>
          <Typography
            variant="body2"
            sx={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5" }}
          >
            {shortDescription}{" "}
            {hasLongDescription && (
              <Box
                component="span"
                sx={{
                  ml: 0.5,
                  color: "primary.main",
                  fontWeight: 500,
                  cursor: "pointer",
                  textDecoration: "underline",
                  whiteSpace: "nowrap",
                }}
                onClick={handleViewDocument}
              >
                See more
              </Box>
            )}
          </Typography>
        </Box>

        <ProgressBar documents={[doc]} />

        <Button
          variant="contained"
          sx={{
            mt: 1,
            textTransform: "none",
            fontWeight: "500",
            borderRadius: "8px",
          }}
          onClick={handleViewDocument}
        >
          View Document
        </Button>
      </Box>

      <AuthPromptDialog
        open={authOpen}
        onClose={() => setAuthOpen(false)}
        title="Login required"
        message="You're trying to access the Transcription Tool. Please login or create an account to begin volunteering."
      />
    </>
  );
};

export default DocumentCard;
